module.exports = "https://cache-nest.services.handy.com/packs/media/src/assets/images/camera-59c3e4db59985e8de20107c74171f5fa.jpg";